import React from "react";
import { ResponsiveDrawerForm } from "./ResponsiveDrawerForm";
import { Button } from "./ui/button";
import Spin from "./Spin";

const Confirmation = (props) => {
  return (
    <ResponsiveDrawerForm
      description={""}
      title={props?.title ? props?.title : "Delete Record"}
      handleOpen={() => {}}
      handleClose={props?.handleClose ? props?.handleClose : () => {}}
      className={props?.className ? props?.className : "w-1/2"}
      open={props?.open}
      buttonClassName={""}
      setOpen={props?.setOpen}
      mobileCancelHidden={true}
      confirmBox={true}
      popupType={props?.popupType ? props?.popupType : ""}
      write={true}
    >
      <div className="relative">
        {props?.loading && <Spin expand={true} smallModal={true} fullscreen={true}/>}
        <div className="text-center">{props?.message}</div>
        <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
          {props?.extraButton && (
            <Button
              type="submit"
              className="mr-3"
              variant="secondary"
              onClick={(e) => {
                e.preventDefault();
                props?.extraButtonAction();
              }}
            >
              Cancel
            </Button>
          )}
          <Button
            type="submit"
            onClick={(e) => {
              e.preventDefault();
              props?.okAction();
            }}
            disabled={props?.disabled || false}
          >
            Yes
          </Button>
          <Button
            className="reset ml-3"
            data-dismiss="modal"
            aria-label="Close"
            variant="secondary"
            disabled={props?.secondDisabled || false}
            onClick={(e) => {
              e.preventDefault();
              props?.cancelAction();
            }}
          >
            No
          </Button>
        </div>
      </div>
    </ResponsiveDrawerForm>
  );
};

export default Confirmation;
